import {
  setInventoryGroupLotId,
  setInventorysLotId,
} from 'features/private-views/farmers-web/groups-list/groupListAction'
import {
  useCheckInventorysLotIdMutation,
  useFetchInventoryGroupLotIdQuery,
} from 'features/private-views/farmers-web/groups-list/groupListApiSlice'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useDispatch } from 'react-redux'
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Spinner,
} from 'reactstrap'

const AssignLotIDModal = ({
  isOpen,
  onCloseModal,
  groupId,
  setIsFetch,
  isDetail,
  selectedInventoryList,
  onClearSelected,
}) => {
  const [lotId, setLotId] = useState('')
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const [checkInventorysLotId, responseCheck] =
    useCheckInventorysLotIdMutation()

  const { data } = useFetchInventoryGroupLotIdQuery(
    { groupId },
    {
      refetchOnMountOrArgChange: true,
      skip: !isOpen || !groupId,
    },
  )

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!lotId) {
      enqueueSnackbar('Lot ID tidak boleh kosong.', { variant: 'warning' })
      return
    }

    setLoading(true)
    try {
      if (isDetail) {
        await dispatch(
          setInventoryGroupLotId({ groupId: groupId, newLotCode: lotId }),
        ).unwrap()
      } else {
        await dispatch(
          setInventorysLotId({
            newLotCode: lotId,
            inventoryIds: selectedInventoryList?.map((e) => e?.id),
          }),
        ).unwrap()
        onClearSelected()
      }

      onCloseModal()
      setLotId('')
      enqueueSnackbar('Lot ID berhasil diatur.', {
        variant: 'success',
      })
      setIsFetch()
    } catch (err) {
      enqueueSnackbar(err || 'Gagal mengatur Lot ID.', { variant: 'error' })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!isDetail && isOpen && selectedInventoryList?.length > 0) {
      checkInventorysLotId({
        inventoryIds: selectedInventoryList?.map((e) => e?.id),
      })
    }
  }, [isDetail, isOpen])

  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpen}
      toggle={() => {
        onCloseModal()
        setLotId('')
      }}
      autoFocus={false}
    >
      <ModalBody>
        <h5>Atur Lot ID ke inventori {isDetail ? 'dalam grup' : ' '} ini.</h5>

        {(data?.haveLotCode || responseCheck?.data?.haveLotCode) && (
          <div className="d-flex align-items-center text-warning mb-2">
            <AlertCircle size={16} className="me-1" />
            <small>Beberapa inventori sudah memiliki Lot ID</small>
          </div>
        )}

        <FormGroup>
          <Label>Lot ID baru</Label>
          <Input
            autoFocus
            value={lotId}
            onChange={(e) => setLotId(e.target.value)}
            placeholder="Masukkan Lot ID baru"
            disabled={loading}
          />
        </FormGroup>

        <div className="d-flex gap-3 mt-3">
          <Button
            onClick={() => {
              onCloseModal()
              setLotId('')
            }}
            outline
            block
            disabled={loading}
            className="btn-cancel"
          >
            Batal
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            block
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : 'OK'}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default AssignLotIDModal
